import { render, staticRenderFns } from "./emailandsmsitem.vue?vue&type=template&id=cc260cf4&scoped=true&"
import script from "./emailandsmsitem.vue?vue&type=script&lang=js&"
export * from "./emailandsmsitem.vue?vue&type=script&lang=js&"
import style0 from "./emailandsmsitem.vue?vue&type=style&index=0&id=cc260cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc260cf4",
  null
  
)

export default component.exports